// extracted by mini-css-extract-plugin
export var socialShareIcons = "share-icons-module--social-share-icons---mnRg";